module.exports = __webpack_public_path__ + "img/icons B_24.f8829377.png";